import {
  Avatar,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Container,
  Divider,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { Fade } from "react-awesome-reveal";
import { useSearchParams } from "react-router-dom";
import { baseUrl, useViewProProfilesQuery } from "../services/apiSlice";

const ViewProfile = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  let jobId = searchParams.get("jobId");
  let UserId = searchParams.get("userId");
  console.log(UserId);
  const { data, error, isError, isSuccess, isFetching } =
    useViewProProfilesQuery(UserId);
  console.log({ data });
  return (
    <>
      <Container>
        <Fade cascade>
          <Box
            // component="form"
            // onSubmit={handleSubmit(onSubmit)}
            className="min-h-screen"
            sx={{ mt: 5, ml: 4 }}
            style={{
              display: "flex",

              // padding: "20px",
              // margin: "4px 10px",
              flexDirection: "column",
            }}
          >
            <Card
              style={{
                display: "flex",
                gridRowGap: "20px",
                // padding: "20px",
                // margin: "4px 10px",
                flexDirection: "column",
              }}
              sx={[
                { mx: 3, px: 4 },
                (theme) => ({
                  [theme.breakpoints.down("321")]: {
                    width: "100%",
                    py: 3,
                    px: 1,
                    mx: 1,
                  },
                }),
              ]}
            >
              <Typography
                variant="h1"
                component="h2"
                className="md:text-3xl text-base uppercase font-extrabold text-center py-2 md:py-4 "
                sx={{ textAlign: "center" }}
              >
                Pro Profiles
              </Typography>{" "}
              <Typography
                variant="p"
                component="p"
                className="md:text-lg text-base uppercase font-bold text-center py-2 md:py-4 "
                sx={{ textAlign: "center" }}
              >
                If this person meet your requirement or qualify for the job you
                can message him or her directly or contact him through call.
                Thanks
              </Typography>{" "}
              <Divider />
              <CardMedia
                component="img"
                height="30%"
                width={"30%"}
                image={`${
                  baseUrl +
                  `upload/profile/` +
                  data?.data?.proFileObject?.files?.path
                }`}
                sx={{ py: 3 }}
                alt="green iguana"
              />
              <CardContent>
                <>
                  <Typography
                    sx={{
                      color: "black",
                      fontSize: 16,
                      textTransform: "capitalize",
                    }}
                    variant="body2"
                    color="text.secondary"
                  >
                    Personal Description
                  </Typography>
                  <Typography
                    sx={{
                      color: "black",
                      fontSize: 16,
                      py: 1,
                      textTransform: "capitalize",
                    }}
                    variant="body2"
                    color="text.secondary"
                  >
                    {data?.data?.proFileObject?.personal_description}
                  </Typography>{" "}
                  <Divider />
                  <Typography
                    variant="body2"
                    sx={{ py: 2 }}
                    color="text.secondary"
                  >
                    Category:{" "}
                    <Typography
                      sx={{
                        color: "black",
                        px: 1,
                      }}
                      variant="span"
                    >
                      {data?.data?.proFileObject?.categories}
                    </Typography>
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ py: 2 }}
                    color="text.secondary"
                  >
                    Experience:{" "}
                    <Typography
                      sx={{
                        color: "black",
                        px: 1,
                      }}
                      variant="span"
                    >
                      {data?.data?.proFileObject?.experience}
                    </Typography>
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ py: 2 }}
                    color="text.secondary"
                  >
                    Hourly rate charge:{" "}
                    <Typography
                      sx={{
                        color: "black",
                        px: 1,
                      }}
                      variant="span"
                    >
                      {data?.data?.proFileObject?.hourlyRate}
                    </Typography>
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ py: 2 }}
                    color="text.secondary"
                  >
                    Email:{" "}
                    <Typography
                      sx={{
                        color: "black",
                        px: 2,
                      }}
                      variant="span"
                    >
                      {data?.data?.proEmailObject?.value}
                    </Typography>
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ py: 2 }}
                    color="text.secondary"
                  >
                    Address:{" "}
                    <Typography
                      sx={{
                        color: "black",
                        px: 1,
                      }}
                      variant="span"
                    >
                      {data?.data?.userObject?.address}
                    </Typography>
                  </Typography>{" "}
                  <Typography
                    variant="body2"
                    sx={{ py: 2 }}
                    color="text.secondary"
                  >
                    zip code:{" "}
                    <Typography
                      sx={{
                        color: "black",
                        px: 1,
                      }}
                      variant="span"
                    >
                      {data?.data?.userObject?.zip_code}
                    </Typography>
                  </Typography>{" "}
                  <Typography
                    variant="body2"
                    sx={{ py: 2 }}
                    color="text.secondary"
                  >
                    Mobile Number:{" "}
                    <Typography
                      sx={{
                        color: "black",
                        px: 2,
                      }}
                      variant="span"
                    >
                      {data?.data?.userObject?.mobile_number}
                    </Typography>
                  </Typography>
                </>
              </CardContent>
            </Card>
          </Box>
        </Fade>
      </Container>
    </>
  );
};

export default ViewProfile;
